import { Router } from '@angular/router';
import { DataModel } from 'common/models/utility-models/base-model';
import { GridModel } from 'common/models/utility-models/list-utility.model';
import { BaseResolver } from './base-resolver';
import { GridWidgetService } from 'common/widget/grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';

export abstract class GridResolver<T extends DataModel, G extends GridModel<T>> extends BaseResolver<G> {
    protected constructor(
        protected ls: GridWidgetService<T, G>,
        protected override router: Router,
        protected systemService: SystemService
    ) {
        super(ls, router);
       
    }
}
